import RecuperacaoReceitas from "../../../services/http/services/RecuperacaoReceitas/RecuperacaoReceitas";

export const getQuantidadeSolicitacaoReceitas = async () => {
    try {
        const response = await RecuperacaoReceitas.getQuantidadeSolicitado();
        return response.quantidade;
    } catch (error: any) {
        return null;
    }
};
